<template>
  <CosFixFooterPage>
    <div class="menu-box">
      <div class="title">{{ t('system.cvk1qq') }}</div>
      <a-spin :spinning="spinning">
        <div class="detail-box">
          <a-form :model="formState" ref="formDetail" name="basic" :wrapper-col="{ span: 22 }" autocomplete="off">
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-item :label="t('system.ibq5bm')" name="topName" class="tree-detail-box">
                  <a-input v-model:value="formState.topName" :disabled="true" style="width: 100%" />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-item
                  :label="t('system.7mh4ly')"
                  name="cnName"
                  :rules="[{ required: true, message: t('common.pleaseInput') }]"
                  class="tree-detail-box"
                >
                  <a-input
                    v-model:value="formState.cnName"
                    :placeholder="t('common.pleaseInput')"
                    v-trim
                    :disabled="!showEditDetail"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item
                  :label="t('system.3rw46j')"
                  name="status"
                  :rules="[{ required: true, message: t('common.pleaseInput') }]"
                  class="tree-detail-box"
                >
                  <a-switch
                    v-model:checked="formState.status"
                    :checked-children="t('system.j8i04n')"
                    :un-checked-children="t('system.426zce')"
                    :checkedValue="0"
                    :unCheckedValue="1"
                    :disabled="!showEditDetail"
                  />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-item
                  :label="t('system.qkqppn')"
                  name="enName"
                  :rules="[{ required: true, message: t('common.pleaseInput') }]"
                  class="tree-detail-box"
                >
                  <a-input
                    v-model:value="formState.enName"
                    :placeholder="t('common.pleaseInput')"
                    v-trim
                    :disabled="!showEditDetail"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item :label="t('system.j36v6p')" name="operator" class="tree-detail-box">
                  <a-input v-model:value="formState.operator" :disabled="true" v-trim />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-item
                  :label="t('system.p6nvup')"
                  name="sort"
                  :rules="[{ required: true, message: t('common.pleaseInput') }]"
                  class="tree-detail-box"
                >
                  <a-input-number
                    :min="0"
                    v-model:value="formState.sort"
                    :placeholder="t('common.pleaseInput')"
                    :disabled="!showEditDetail"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item :label="t('system.fvakdn')" name="operationTime" class="tree-detail-box">
                  <a-input v-model:value="formState.operationTime" :disabled="true" v-trim />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-item :label="t('system.wl73jo')" name="comment" class="tree-detail-box">
                  <a-input
                    v-model:value="formState.comment"
                    :placeholder="t('common.pleaseInput')"
                    v-trim
                    :disabled="!showEditDetail"
                  />
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
        </div>
      </a-spin>
    </div>
    <template #footer>
      <a-button type="primary" html-type="submit" @click="handleSubmit" :disabled="!showEditDetail">{{
        t('btn.save')
      }}</a-button>
    </template>
  </CosFixFooterPage>
</template>

<script lang="ts">
import { defineComponent, ref, toRefs, watch, PropType } from 'vue'
import { getIdServiceParam, saveServiceParam, updateServiceParam } from '@/api/systemSetting/index'
import type { DetailServiceParamBackData } from '@/typings/api/systemSetting'
import { TreeDetail } from '../hooks/enum'
import type { SystemSetting } from '@/types/systemSetting'
import { DcMessage } from '@dc-platform/dc-components'
import CosFixFooterPage from '@/components/CosFullLayout/fixFooterPage.vue'
import { useI18n } from 'vue-i18n'
export default defineComponent({
  props: {
    data: {
      type: Number,
      default: 0
    },
    addData: {
      type: Object as PropType<SystemSetting.AddDataType>
    },
    showEdit: {
      type: Boolean,
      default: false
    }
  },
  components: {
    CosFixFooterPage
  },
  setup(props, { emit }) {
    const { t } = useI18n()
    const formDetail: any = ref(null)
    const formState = ref<DetailServiceParamBackData>({
      cnName: '',
      comment: '',
      enName: '',
      operationTime: '',
      operator: '',
      sort: '',
      status: 0,
      topName: '-'
    })
    const spinning = ref<boolean>(false)
    const detailId = ref<number>()
    const addData = ref()
    const selectData = toRefs(props).data
    const submitType = ref('add')
    const showEditDetail = ref(false)
    watch(props, () => {
      detailId.value = props.data
      if (props.data === TreeDetail.EMPTY) {
        submitType.value = 'add'
        formDetail.value?.resetFields()
      } else if (props.data === TreeDetail.ADDNEW) {
        submitType.value = 'add'
        addData.value = props.addData
        formDetail.value?.resetFields()
      } else if (props.data === TreeDetail.ZERO) {
        return
      } else {
        submitType.value = 'edit'
        getDetail(props.data)
      }

      formState.value.topName = props.addData?.name ? props.addData?.name : '-'
      showEditDetail.value = props.showEdit
    })

    const getDetail = async (id: number) => {
      try {
        spinning.value = true
        const res: any = await getIdServiceParam({
          paramId: id
        })
        formState.value = res.data
          ? {
              cnName: res.data.cnName,
              comment: res.data.comment,
              enName: res.data.enName,
              operationTime: res.data.operationTime,
              operator: res.data.operatorName,
              sort: res.data.sort,
              status: res.data.status,
              topName: res.data.parentCnName ? res.data.parentCnName : '-'
            }
          : {
              cnName: '',
              comment: '',
              enName: '',
              operationTime: '',
              operator: '',
              sort: '',
              status: 0,
              topName: ''
            }
        spinning.value = false
      } catch (error) {
        spinning.value = false
        console.log('getDetailerror: ', error)
      }
    }
    const handleSubmit = () => {
      try {
        formDetail.value.validate().then(async () => {
          if (submitType.value === 'add') {
            await saveServiceParam(
              {
                ...formState.value,
                parentId: addData.value.id,
                appId: addData.value.appId
              },
              {
                subdomain: addData.value.subdomain
              }
            )
            DcMessage.success(t('system.yi68r7'))
            formDetail.value?.resetFields()
            emit('successRefresh')
          }
          if (submitType.value === 'edit') {
            await updateServiceParam(
              {
                paramId: detailId.value,
                ...formState.value
              },
              {
                subdomain: formState.value.subdomain
              }
            )
            emit('successRefresh')
            DcMessage.success(t('system.tekfs6'))
          }
        })
      } catch (error) {
        console.log('handleSubmit error: ', error)
      }
    }
    return {
      t,
      selectData,
      formState,
      spinning,
      formDetail,
      handleSubmit,
      showEditDetail
    }
  }
})
</script>
<style lang="scss" scoped>
:deep(.ant-switch-checked .ant-switch-handle) {
  left: 65%;
}
.menu-box {
  padding: 16px 16px 0;
  .detail-box {
    box-sizing: border-box;
    padding: 30px 250px;
  }
  .title {
    font-weight: 500;
    font-size: 16px;
    color: #132043;
    padding-left: 8px;
    position: relative;
    margin-bottom: 12px;
  }
  .title::after {
    width: 2px;
    height: 20px;
    background-color: #1d4cd2;
    position: absolute;
    left: 0;
    top: 3px;
    content: '';
  }
  .input {
    width: 80px;
    display: inline-block;
    margin: 0 5px;
  }
  .subTitle {
    font-weight: 500;
    font-size: 16px;
    color: #333333;
    height: 40px;
    display: flex;
    align-items: center;
    margin: 25px 20px 16px;
    border-bottom: 1px solid rgb(235, 239, 241);
  }
  p {
    padding-left: 20px;
    margin-bottom: 10px;
  }
  .footer-box {
    width: 100%;
    height: 64px;
    background: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom: 0;
    left: 0;
  }
  .line-bg {
    width: 100%;
    height: 8px;
    background-color: rgb(249, 249, 255);
    padding: 0 16px;
    box-sizing: content-box;
    left: -16px;
    position: absolute;
    bottom: 64px;
  }
}
.tree-detail-box {
  display: block !important;
}
</style>
